module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_White_DKGrey.03168965.png";